import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EAdSectionBidStatus } from 'types/adManagement';
import { Tag } from 'antd';

export const AdBidStatusTag: FC<{ status: EAdSectionBidStatus }> = ({ status }) => {
	const { t: tAdManagement } = useTranslation('ad-management');

	const COLORS: Record<EAdSectionBidStatus, string> = {
		[EAdSectionBidStatus.PENDING]: 'gold',
		[EAdSectionBidStatus.SCHEDULED]: 'purple',
		[EAdSectionBidStatus.QUEUED]: 'greekblue',
		[EAdSectionBidStatus.IN_PROGRESS]: 'orange',
		[EAdSectionBidStatus.DEPLETED]: 'red',
		[EAdSectionBidStatus.PAUSED]: 'yellow',
		[EAdSectionBidStatus.CANCELLED]: 'volcano',
		[EAdSectionBidStatus.COMPLETED]: 'green',
	};
	const label = tAdManagement(`enums.EAdSectionBidStatus.${status}`).toUpperCase();

	return <Tag color={COLORS[status]}>{label}</Tag>;
};
